export default "__VITE_ASSET__BDTDmw$r__"